var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWidgetGroupMaker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 39,
    viewBox: "0 0 54 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9926 17.4631C11.8555 17.4403 11.6954 17.4403 11.5583 17.4631C8.40341 17.3488 5.88867 14.7655 5.88867 11.5649C5.88867 8.29574 8.51772 5.66669 11.7869 5.66669C15.056 5.66669 17.6851 8.3186 17.6851 11.5649C17.6622 14.7655 15.1475 17.3488 11.9926 17.4631Z",
    fill: "#FBD178"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1596 17.4631C43.0225 17.4403 42.8624 17.4403 42.7253 17.4631C39.5704 17.3488 37.0557 14.7655 37.0557 11.5649C37.0557 8.29574 39.6847 5.66669 42.9539 5.66669C46.223 5.66669 48.8521 8.3186 48.8521 11.5649C48.8292 14.7655 46.3145 17.3488 43.1596 17.4631Z",
    fill: "#FBD178"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6394 12.8312C27.4902 12.8063 27.3161 12.8063 27.1669 12.8312C23.7353 12.7069 21 9.89693 21 6.4156C21 2.85967 23.8597 0 27.4156 0C30.9715 0 33.8312 2.88453 33.8312 6.4156C33.8063 9.89693 31.071 12.7069 27.6394 12.8312Z",
    fill: "#31C384"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1113 35L19.1113 28.0698C19.1113 25.1327 19.1114 22.2612 21.4616 20.1181C24.5735 17.294 29.6715 17.294 32.7834 20.1181C35.1338 22.2412 35.1669 24.7733 35.1669 28.0698L35.1669 35",
    stroke: "#31C384",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.167 35L35.167 32.328C35.167 29.4608 35.167 26.6575 37.3255 24.5653C40.1835 21.8084 44.8656 21.8084 47.7235 24.5653C49.8821 26.638 49.9125 29.1098 49.9125 32.328L49.9125 35",
    stroke: "#FBD178",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 35L4 32.376C3.99998 29.5603 4.00003 26.8074 6.21206 24.7528C9.14083 22.0454 13.939 22.0454 16.8678 24.7528C19.08 26.7882 19.1111 29.2157 19.1111 32.376L19.1111 35",
    stroke: "#FBD178",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetGroupMaker);
export default __webpack_public_path__ + "static/media/WIDGET_GROUP_MAKER.87993d68213f389dd046716abf37ccdf.svg";
export { ForwardRef as ReactComponent };